import Link from "next/link";
import React from "react";

import styles from "./article-tile.module.scss";

export type ArticleTileProps = {
    title: string;
    href?: string;
    onClick?: () => void;
    className?: string;
    titleClassName?: string;
    leftIcon?: React.ReactNode;
    rightIcon?: React.ReactNode;
    subtitle?: React.ReactNode;
};

const ArticleTile: React.FC<ArticleTileProps> = ({
    title,
    href,
    onClick,
    className,
    titleClassName,
    leftIcon,
    rightIcon,
    subtitle,
}) => {
    const content = (
        <>
            <span className={styles.left}>
                {leftIcon ? <span className={styles.leftIcon}>{leftIcon}</span> : null}
                <span className={styles.text}>
                    <span
                        className={`${styles.title}${titleClassName ? ` ${titleClassName}` : ""}`}
                    >
                        {title}
                    </span>
                    {subtitle ? <span className={styles.subtitle}>{subtitle}</span> : null}
                </span>
            </span>
            {rightIcon ? <span className={styles.rightIcon}>{rightIcon}</span> : null}
        </>
    );

    if (href) {
        return (
            <Link
                href={href}
                onClick={onClick}
                className={`${styles.tile} ${className ?? ""}`.trim()}
            >
                {content}
            </Link>
        );
    }

    if (onClick) {
        return (
            <button onClick={onClick} className={`${styles.tile} ${className ?? ""}`.trim()}>
                {content}
            </button>
        );
    }

    return <div className={`${styles.tile} ${className ?? ""}`.trim()}>{content}</div>;
};

export default ArticleTile;
